export default "__VITE_ASSET__kAAudklK__"